export default __webpack_public_path__ + "images/PQ.ef1f204.png";